import React, { Component } from 'react';
import ExportCreditsComp from '../../../../components/sales/credit/export';

export default class ExportCredits extends Component {
	render() {
		return <ExportCreditsComp />;
	}
}
